module.exports = __webpack_public_path__ + "img/svg - right window.5a0d1d95.svg";